//@ts-nocheck
//@ts-nocheck
import { useState } from "react";
import { OverlayRouter } from "../../../../../../components/OverlayRouter";
import { useSearchViewModel } from "../../../../../../home-tutoring/request-flow/old/store";
import { IUseSearchViewModel } from "../../../../../../home-tutoring/request-flow/old/store/types";
import {
  PricingPage as NewPricingPage,
  PricingPageType,
} from "./components/PricingPage";

// const oo = generateOptionDetails(payload, false);
export const formatToString = (list: string[], final) => {
  let toString = "";
  list.forEach((item, index) => {
    if (list.length > 1 && index === list.length - 1) {
      toString += `and ${item}`;
    } else if (list.length <= 1) {
      toString += final ? `${item}` : `${item} `;
    } else {
      toString += `${item}, `;
    }
  });
  return toString;
};

function teacherDisplayInfo(
  requestInfo: IUseSearchViewModel["rawData"],
  teacherOptionsValue: any
) {
  const renderTeacherBreakdown = (type: string, options: any[]) => {
    const currentOptionObj = options.find((option: any) => option[type]);
    const currentOptions = currentOptionObj ? currentOptionObj[type] : [];
    const inString = ["First", "Second", "Third", "Fourth", "Fifth"];

    return currentOptions.map((option: any, index: number) => {
      return {
        title: `${inString[index]} teacher`,
        desc: `takes ${formatToString(option.names)} in ${formatToString(
          option.subjectGroup
        )}`,
      };
    });
  };
  const children = requestInfo.childDetails.map(
    (child: any) => child.firstName
  );
  const subjects = new Set(
    requestInfo.childDetails
      .map((detail: any) => detail.classDetail.subjects)
      .flat()
  );
  const specializedTeachersBreakdown = renderTeacherBreakdown(
    "Specialized teachers",
    teacherOptionsValue
  );
  const separateTeachersBreakdown = renderTeacherBreakdown(
    "Separate teachers",
    teacherOptionsValue
  );
  return {
    separateTeacherInfo: {
      one: {
        info: "One teacher takes all your children the subjects selected",
        breakdown: [
          {
            title: "",
            desc: `One teacher takes ${formatToString(
              children
            )} in ${formatToString([...subjects] as string[])}`,
          },
        ],
      },
      specialized: {
        info: "Each teacher takes the subjects in which they specialize",
        breakdown: specializedTeachersBreakdown,
      },
      separate: {
        info: "Each child gets a separate tutor to teach all subjects",
        breakdown: separateTeachersBreakdown,
      },
    },
  };
}

const renderPricingOptions = (
  requestInfo: IUseSearchViewModel["rawData"],
  prices: any,
  teacherOptionsValue: any
) => {
  const inDiaspora =
    requestInfo.contactDetails.country.toLowerCase() !== "nigeria";
  const purposes = requestInfo.childDetails.map(
    (detail: any) => detail.classDetail.purpose
  );

  const lessonHours = requestInfo.lessonDetails.lessonSchedule.lessonHours;

  const options = [
    {
      popular: false,
      name: "Lite",
      description:
        "Keep learners engaged, motivated and on track with school work and assignments",
      features: [
        "1 Verified subjects matter expert",
        "1-3 years experience",
        "Physical lessons in your home",
        "Up to 2 hours per session",
        "Subjects covered: English Language, Mathematics and Basic science only",
        "Nigerian Curriculum",
        "Flexible lesson schedule based on tutor's availability",
        "Tutor helps with homework, studies and test prep",
        "Exams covered: School exam prep, common entrance, BECE/JSCE",
        "Assessment and progress reports",
      ],
      separateTeacherInfo: null,
    },
    {
      popular: true,
      name: "Standard",
      description: `Prepare for exams, strengthen foundation, challenge learners to improve grades and drive better performance`,
      features: [
        "Verified Subject Matter Expert",
        "Exam prep and Early child expert",
        "Up to 10 years experience",
        "Physical lessons or Online lessons",
        `${lessonHours} hour${lessonHours > 1 ? "s" : ""} per session`,
        "Lessons cover all subjects selected",
        "Curriculum supported: Nigerian, British, EYFS, American",
        "Tutors are available at your preferred schedule",
        `Tutor helps with ${purposes.join(", ")}`,
        `Exams covered: ${
          !inDiaspora
            ? "School exam prep, common entrance, Checkpoint, BECE/JSCE, IGCSE, SSCE, UTME"
            : "National tests and teacher assessments, GL-PT test series, Checkpoint, 11+ Exams, IGCSE"
        }`,
        "Assessment and progress reports",
      ],
      ...teacherDisplayInfo(requestInfo, teacherOptionsValue),
    },
  ];

  const pricingOptions = prices.map((price: any, index: number) => {
    console.log("price", price);
    const value = prices.length > 1 ? options[index] : options[1];

    return {
      ...value,
      price: price.exchangePrice,
      currency: price.exchangeCurrency,
      lessons: price.lessons,
      duration: price.duration,
      teacherOptions: price.teacherOptions,
    };
  });
  return pricingOptions;
};

export const PricingPage = ({
  onEditRequest,
  currencies,
  isLiteRequest,
  canChangeNoOfTutors = true,
  agentSupportNumber,
  showNumOfTutors,
  withPreAssessment,
  isNewUser,
  ...props
}: IUseSearchViewModel & {
  onEditRequest: () => any;
  selectedPlan?: number;
  currencies: PricingPageType["currencies"];
  isLiteRequest: boolean;
  agentSupportNumber: string;
  canChangeNoOfTutors?: boolean;
  showNumOfTutors?: boolean
  withPreAssessment?: boolean;
  isNewUser?: boolean;
}) => {
  const [selectedPlan, setSelectedPlan] = useState<number>(
    props.selectedPlan || -1
  );
  const { clientRequest: store, useRequestDataProps } =
    useSearchViewModel(props);
  const { prices: priceFunc, pricingStore } = useRequestDataProps;
  
  const teachingOptions: any =
    useRequestDataProps.childStore.teacherSplitOptions();

  let teacherOptions = Object.keys(teachingOptions) || [];
  
  if (
    teacherOptions.length === 1 &&
    teacherOptions.map((o) => o.toLowerCase()).includes("one teacher")
  ) {
    teacherOptions = [];
  }
  // if (
  //   !teacherOptions.map((o) => o.toLowerCase()).includes("separate teachers")
  // ) {
  //   teacherOptions = [];
  // }
  const teacherOptionsValue = teacherOptions.map((key: string) => {
    if (teachingOptions[key]) {
      return { [key]: teachingOptions[key] };
    }
    return {};
  });

  const prices = priceFunc() || [];
  const pricingOptions = renderPricingOptions(
    props.rawData,
    prices,
    teacherOptionsValue
  );
  
  return (
    <OverlayRouter>
      <NewPricingPage
        onPlanSelected={(planIndex) => {
          const selectedPrice = prices[planIndex];
          const plan =
            prices.length > 1
              ? pricingOptions[planIndex]
              : pricingOptions[pricingOptions.length - 1];
          setSelectedPlan(planIndex);
          return store.onPlanSelected({
            ...selectedPrice,
            planName: plan.name,
            teacherOption:
              useRequestDataProps.teacherSelectStore.teacherOption ||
              (teacherOptions.length > 0 ? teacherOptions[0] : ""),
          });
        }}
        pricingOptions={pricingOptions}
        selectedPlan={selectedPlan}
        onEditRequest={onEditRequest}
        loading={store.loading}
        viewModel={useRequestDataProps}
        currencies={currencies}
        selectedCurrency={pricingStore.paymentCurrency}
        onCurrencySelected={(currency) =>
          pricingStore.setPaymentCurrency(currency)
        }
        isLiteRequest={isLiteRequest}
        canChangeNoOfTutors={canChangeNoOfTutors}
        callNumber={agentSupportNumber}
        showNumOfTutors={showNumOfTutors}
        withPreAssessment={withPreAssessment}
        isNewUser={isNewUser}
      />
    </OverlayRouter>
  );
};
